import { isServerSide } from '../server.js';
let isGuardian;
const isGuardianDomain = () => {
    if (typeof isGuardian === "undefined") {
        if (isServerSide) {
            isGuardian = true;
        }
        else {
            isGuardian = window.location.host.endsWith(".theguardian.com");
        }
    }
    return isGuardian;
};
export { isGuardianDomain };
